import { Pagination } from 'src/app/shared/models';

export interface SharedState {
  pagination: Pagination;
  isLoading: boolean;
  error: any;
}

export const initialState: SharedState = {
  isLoading: false,
  error: null,
  pagination: null,
};
